import React, { useState } from 'react';
import { ConfigProvider, Spin } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { AppContext, initialState } from './model';
import RootLayout from './components/RootLayout';
import { CloseSquareOutlined } from '@ant-design/icons';
class ErrorBoundary extends React.Component<any> {
  state = {
    hasError: false
  }
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    // 更新 state 使下一次渲染能够显示降级后的 UI
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    console.log(error)
    // 你同样可以将错误日志上报给服务器
  }

  render() {
    if (this.state.hasError) {
      // 你可以自定义降级后的 UI 并渲染
      return <h1> <CloseSquareOutlined /> 发生未知错误</h1>;
    }

    return this.props.children;
  }
}

const App: React.FC = () => {
  const [app, setApp] = useState(initialState);
  const setState = (name: string, value: any) => {
    setApp({ ...app, [name]: value })
  };

  return (
    <ErrorBoundary>
      <ConfigProvider locale={zhCN}>
        <AppContext.Provider value={{ ...app, setState }}>
          <Spin spinning={app.loading}>
            <RootLayout />
          </Spin>
        </AppContext.Provider>
      </ConfigProvider>
    </ErrorBoundary>

  );
}

export default App;